import useMain from '../../../../../hooks/useMain';

const FilterIndicators = ({ selectedOptions, onOptionSelect }) => {
	const { theme } = useMain();

	return (
		<div className='d-flex flex-wrap justify-content-start align-items-center mt-4'>
			{selectedOptions.map((option, index) => (
				<button
					onClick={() => onOptionSelect(option)}
					key={index}
					className={`btn btn-sm btn-outline-set4-${theme} me-2 mb-2`}>
					<div className='d-flex justify-content-between align-items-center'>
						<span>{option.label}</span>
						<i className='fas fa-times ms-2'></i>
					</div>
				</button>
			))}
		</div>
	);
};

export default FilterIndicators;
